import { SuperAdminConstants } from '../../../_constants';

const initialState = { getOrgDetailsLoading: true, data: '', error: false };

export function getOrgDetailsReducer(state = initialState, action) {
    
    switch (action.type) {
        case SuperAdminConstants.REQUEST_GET_ORG_DETAILS:
            return {
                getOrgDetailsLoading: true,
                data: '',
                error: false
            };
        case SuperAdminConstants.RECEIVE_GET_ORG_DETAILS:
            return {
                getOrgDetailsLoading: false,
                data: action.getOrgDetails,
                error: false
            };
        case SuperAdminConstants.GET_ORG_DETAILS_ERROR:
            return {
                getOrgDetailsLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/SuperAdmin/OrgDetails/getOrgDetails.reducer.js